var exports = {
  "MT": "DesktopSettingsView.module__searchContainer___MWlCZX",
  "FY": "DesktopSettingsView.module__backButtonContainer___MWlCZX",
  "j2": "DesktopSettingsView.module__backIcon___MWlCZX",
  "wV": "DesktopSettingsView.module__noResults___MWlCZX",
  "Gn": "DesktopSettingsView.module__tabLabel___MWlCZX",
  "fC": "DesktopSettingsView.module__badgeContainer___MWlCZX",
  "tM": "DesktopSettingsView.module__sectionLabelWithBadge___MWlCZX",
  "bS": "DesktopSettingsView.module__legalLinks___MWlCZX",
  "z8": "DesktopSettingsView.module__footerContent___MWlCZX",
  "el": "DesktopSettingsView.module__legalLink___MWlCZX",
  "Ic": "DesktopSettingsView.module__footerSpacer___MWlCZX",
  "Ij": "DesktopSettingsView.module__fullWidth___MWlCZX",
  "QM": "DesktopSettingsView.module__breadcrumbTitle___MWlCZX",
  "Yr": "DesktopSettingsView.module__breadcrumbButton___MWlCZX",
  "BV": "DesktopSettingsView.module__breadcrumbChevron___MWlCZX",
  "rV": "DesktopSettingsView.module__breadcrumbCurrent___MWlCZX",
};

module.exports = exports;
